App.controller('HealthPzuwListCtrl', ['$scope', '$stateParams', '$sce', '$state', '$http', '$mdDialog', 'Config', 'insuranceService', 'profileService', '$timeout', 'FileSaver', 'Blob', '$rootScope', 'healthInsuranceService', 'packageService', function ($scope, $stateParams, $sce, $state, $http, $mdDialog, Config, insuranceService, profileService, $timeout, FileSaver, Blob, $rootScope, healthInsuranceService, packageService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'mypackage';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.hasActiveDeclaration = false;
    $scope.hasEffectiveDeclaration = false;

    let isAnniversaryMonth = (new Date().getMonth() + 1) === $rootScope.CONFIGURATOR.healthInsurancePzuw.anniversaryChangesMonth;

    $scope.declarationStatus = 'Pakiet czeka na aktywację';

    function checkIfUserHasActiveDeclaration() {
        if ($scope.package) {
            if ($scope.package.status === 'READY') {
                $scope.declarationStatus = 'Pakiet czeka na aktywacje – aktywacja od ' + $scope.package.proposedDate;
            } else if ($scope.package.status === 'ACTIVE') {
                $scope.declarationStatus = 'Pakiet aktywny od ' + moment(new Date($scope.package.activeDate)).format('YYYY-MM-DD');
            } else if ($scope.package.status === 'WITHDRAWN') {
                $scope.declarationStatus = 'Zakończenie pakietu z dniem ' + moment(new Date($scope.package.endDateBasedOnWithdrawalDate)).format('YYYY-MM-DD');
            } else if ($scope.package.status === 'ENDED') {
                $scope.declarationStatus = 'Pakiet zakończony z dniem ' + moment(new Date($scope.package.endedDate)).format('YYYY-MM-DD');
            }
            $scope.hasActiveDeclaration = $scope.package.status === 'ACTIVE';
            $scope.hasEffectiveDeclaration = $scope.package.status === 'ACTIVE' || $scope.package.status === 'WITHDRAWN' || $scope.package.status === 'ENDED';
            $scope.canChange = ($scope.package.status !== 'WITHDRAWN' && $scope.package.status !== 'ENDED') || isAnniversaryMonth;
        }
    }

    $scope.package = null;
    healthInsuranceService.getLastDeclaration('PZUW').then(function (data) {
        if (data.status === 200) {
            let pkg = data.data;
            console.log('lasthealthInsurance.then', data, pkg);

            if (!pkg || !Object.keys(pkg).length) {
                $state.go('root.health.package');
                return;
            }
            $scope.package = pkg;
            if (typeof $scope.package.rehabilitation !== 'undefined' && $scope.package.rehabilitation) {
                $scope.package.benefit.name += ' + Rehabilitacja ambulatoryjna';
                $scope.package.benefit.summaryPrice += $scope.package.benefit.rehabilitationPrice;
                $scope.package.benefit.workerPrice += $scope.package.benefit.rehabilitationPrice;
            }

            if ($scope.package.seniors.length  > 0) {
                $scope.package.benefit.name += ' + Komfort Senior';
                let totalSeniorPrice = $scope.package.seniors.length * $scope.package.benefit.seniorPrice;
                $scope.package.benefit.summaryPrice += totalSeniorPrice;
                $scope.package.benefit.workerPrice += totalSeniorPrice;
            }
            checkIfUserHasActiveDeclaration();
        }
    });

    let page = 0;
    $scope.current = page;
    $scope.searchString = '';

    loadActivities(page);

    function loadActivities(page) {
        let criteria = {
            pageNumber: page,
            pageSize: 10,
            searchString: $scope.searchString,
            insurer: 'PZUW'
        };
        healthInsuranceService.getDeclarations(criteria).then(function (data) {
            if (data.status === 200) {
                angular.forEach(data.data.data, function (single) {
                    single.numberOfRelatives = (single.partner ? 1 : 0) + single.children.length + single.seniors.length;
                });
                $scope.activities = data.data.data;
                $scope.numberOfPages = data.data.pages;
                // $scope.buildScroll();
                // console.log($scope.activities);
            }
        });
    }

    $scope.search = function () {
        loadActivities(0);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page);
        $scope.current = page;
    };

    $scope.buildScroll = function () {
        $timeout(function () {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    };

    $scope.isEndOfAccession = function () {
        return packageService.isEndOfAccession();
    };

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis: "x",
            theme: "dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced: {autoExpandHorizontalScroll: true},
            callbacks: {
                onInit: function () {

                },
                onScroll: function () {

                }
            }
        });
    }

    $scope.getDeclaration = function (ev, value) {
        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        let id = value.uuid, barcode = value.barcode || '';

        healthInsuranceService.getDeclaration(id).then(function (data) {
            if (data.status === 200) {
                let blobData = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(blobData, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

    $scope.getStatement = function (ev, id) {
        let el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        healthInsuranceService.getStatement(id).then(function (data) {
            if (data.status === 200) {
                let blobData = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(blobData, 'oświadczenie.pdf');
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    };

}]);
